import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Cushion, FlexContainer, Typography } from '@pitchero/react-ui';
import Icon from '../icon';
import { withTranslation } from '../../lib/i18n';

const SearchBox = ({
  onSearchCancel,
  onSearchChange,
  initialSearchTerm,
  inputRef,
  t,
  showClose,
}) => {
  const [searchTerm, setSearchTerm] = useState(initialSearchTerm);

  const onKeyDown = (event) => {
    const key = event.key || event.keyCode;
    if (key === 'Enter' || key === 13) {
      onSearchChange(searchTerm);
    }
  };

  return (
    <Cushion vertical="small" horizontal="medium" component="div">
      <FlexContainer alignItems="center">
        <FlexContainer
          style={{ border: '1px solid black', borderRadius: '100px', padding: '5px', flex: 1 }}
        >
          <Cushion horizontal="small" component="div" style={{ flex: 1 }}>
            <Typography preset="subtitle--small" component="div">
              <input
                name="search"
                type="text"
                placeholder={t('common:search')}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={onKeyDown}
                ref={inputRef}
                style={{
                  border: 'none',
                  background: 'none',
                  outline: 'none',
                  transition: 'width 1.5s ease',
                  width: '100%',
                }}
              />
            </Typography>
          </Cushion>
          <Icon
            name="search"
            size={18}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              onSearchChange(searchTerm);
            }}
          />
        </FlexContainer>
        {showClose && (
          <Cushion left="small">
            <Icon
              name="cross"
              color="black"
              onClick={onSearchCancel}
              size={18}
              style={{ cursor: 'pointer' }}
            />
          </Cushion>
        )}
      </FlexContainer>
    </Cushion>
  );
};

SearchBox.defaultProps = {
  initialSearchTerm: '',
};

SearchBox.propTypes = {
  inputRef: PropTypes.func.isRequired,
  initialSearchTerm: PropTypes.string,
  onSearchCancel: PropTypes.func.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  showClose: PropTypes.bool.isRequired,
};

export default withTranslation(['common'])(SearchBox);
